import "../../chunks/nexus-client-client-TGyNJoMo.mjs";
import { reco } from "../index-client.mjs";
const recoCinemas = reco.cinemas;
const renderBounceLayerRecommendations = recoCinemas.renderBounceLayerRecommendations;
const renderOrderOverviewRecommendations = recoCinemas.renderOrderOverviewRecommendations;
const renderPdpRecommendations = recoCinemas.renderPdpRecommendations;
const renderWishlistRecommendations = recoCinemas.renderWishlistRecommendations;
export {
  recoCinemas,
  renderBounceLayerRecommendations,
  renderOrderOverviewRecommendations,
  renderPdpRecommendations,
  renderWishlistRecommendations
};
/*                                     */
